import { createSelector } from '@ngrx/store';
import { IPassLikeCollectionState } from '../../states/pass-like-collection.state';
import { getPassLikeCollectionState } from '../../states/pass-like-getters.state';
import { adapter, invitationsInitialStates } from './invitations.reducer';
import { IInvitationsState } from './invitations.state';

export const getInvitationsState = createSelector(
	getPassLikeCollectionState,
	(state: IPassLikeCollectionState) => state.invitations ?? invitationsInitialStates
);

export const getInvitationLoadingState = createSelector([getInvitationsState], (state: IInvitationsState) => state.loading);
export const getInvitationLoadedState = createSelector([getInvitationsState], (state: IInvitationsState) => state.loaded);
export const getInvitationsCollection = adapter.getSelectors(getInvitationsState).selectAll;
export const getInvitationsTotalNumber = adapter.getSelectors(getInvitationsState).selectTotal;
